var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0875 6.0625L13.9375 9.9125L7.1125 16.7375C6.9375 16.9125 6.7625 17 6.5 17H3.875C3.35 17 3 16.65 3 16.125V13.5C3 13.2375 3.0875 13.0625 3.2625 12.8875L10.0875 6.0625ZM16.7375 5.8875C17.0875 6.2375 17.0875 6.7625 16.7375 7.1125L15.1625 8.6875L11.3125 4.8375L12.8875 3.2625C13.2375 2.9125 13.7625 2.9125 14.1125 3.2625L16.7375 5.8875Z",
    fill: "#B5B5B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGray);
export default __webpack_public_path__ + "static/media/edit-icon-gray.44ba106b6f2d7715b42e88f5f8761d52.svg";
export { ForwardRef as ReactComponent };